export const featureDataCommercialsnowRemoval = {
    mainTitle: 'Why Choose HRD for Snow Removal?',
    items: [
        {
            number: '01',
            heading: 'Fast & Reliable Service – We monitor weather conditions to proactively clear snow and ice before it becomes a hazard.'
        },
        {
            number: '02',
            heading: 'Heavy-Duty Equipment & Trained Crews – Using plows, loaders, and hand tools to efficiently clear all property sizes.'
        },
        {
            number: '03',
            heading: 'Eco-Friendly Ice Melt & De-Icers – Safe for concrete, landscaping, and the environment.'
        },
        {
            number: '04',
            heading: 'Minimized Business Disruption – Strategic scheduling to avoid interference with daily operations.'
        },
        {
            number: '05',
            heading: 'Stay Safe & Operational This WinterFrom corporate offices and retail shops to hotels, warehouses, and multi-unit buildings, we provide expert interior painting services to elevate and protect your property.'
        }
    ],
    title: "Stay Safe & Operational This Winter",
    subtitle:
        'From corporate offices and retail shops to hotels, warehouses, and multi-unit buildings, we provide expert interior painting services to elevate and protect your property.',
    ctaText:
        'CONTACT US TODAY TO DISCUSS HOW WE CAN PROTECT AND ENHANCE YOUR PROPERTY!',
    backgroundImage: '/assets/imgs/services/6CommercialsnowRemoval/featuregridSection/fondo.png'
};
